var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"customers"},[_c('ul',{staticClass:"customers__list"},_vm._l((_vm.items),function(customer,index){return _c('li',{key:customer.id + index,staticClass:"customers__item",style:({
				zIndex: _vm.items.length + 100 - index
			})},[_c('CustomerCard',{attrs:{"customer":customer}})],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }